<template>
  <div class="authorize">
    <div class="isAuthorize">
      <div class="v-flex-center">
        <div class="v-m-r-10">
          <div class="v-m-b-14" style="color: #666666">认证中心-授权页</div>
          <h3>您是否确认授权?</h3>
          <div style="margin-top: 34%">
            <el-button type="primary" @click="agree">同意</el-button>
            <el-button type="danger" @click="cancel">拒绝</el-button>
            <el-button @click="toHome">返回主页</el-button>
          </div>
        </div>
        <div>
          <img src="@/assets/imgs/authIcon.png" style="width: 280px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { getParams } from "@/utils/getParams";
import oauth2Config from "@/config/oauth2Config";
import qs from "qs";
import {doConfirm} from "@/common/api/http.api.login";
const router = useRouter();
// 同意
const agree = () => {
  doConfirm({
    client_id: getParams(window.location.hash.split("?")[1])?.client_id,
    scope: getParams(window.location.hash.split("?")[1])?.scope,
  })
    .then(() => {
      var authorUrl = oauth2Config.userAuthorizationUri;
      authorUrl =
        authorUrl +
        ("?" +
          qs.stringify({
            client_id: getParams(window.location.hash.split("?")[1])?.client_id,
            response_type: "code",
            scope: "userinfo",
            redirect_uri: getParams(window.location.hash.split("?")[1])
              ?.redirect_uri,
          }));
      window.location.href = authorUrl;
    })
    .catch(() => {});
};
// 拒绝
const cancel = () => {
  router.push("/homeContent");
};
const toHome = () => {
  router.push("/homeContent");
};
</script>

<style scoped lang="scss">
.authorize {
  background: #fff;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .isAuthorize {
    //width: 400px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.16);
    border-radius: 17px 17px 17px 17px;
    padding: 30px;
  }
}
</style>
